import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['contactsContainer', 'template', 'contactCard']

  addContact(event) {
    event.preventDefault()

    const clone = this.templateTarget.content.cloneNode(true)
    const contactNumber = this.contactCardTargets.length + 1

    // Update contact number
    const numberSpan = clone.querySelector('[data-registration--invitation-contacts-target="contactNumber"]')
    if (numberSpan) numberSpan.textContent = contactNumber

    this.contactsContainerTarget.appendChild(clone)

    // Focus on email input
    const lastCard = this.contactCardTargets[this.contactCardTargets.length - 1]
    lastCard.querySelector('input[type="email"]')?.focus()
  }

  removeContact(event) {
    event.preventDefault()

    const card = event.target.closest('[data-registration--invitation-contacts-target="contactCard"]')
    if (card) {
      card.remove()
      this.updateContactNumbers()
    }
  }

  updateContactNumbers() {
    this.contactCardTargets.forEach((card, index) => {
      const numberSpan = card.querySelector('[data-registration--invitation-contacts-target="contactNumber"]')
      if (numberSpan) numberSpan.textContent = index + 1
    })
  }
}
